import { apiClient } from '@app/lib'
import { type SugarKnowledgeBaseResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useKnowledgeBase = ({ programYearId }: { programYearId: string | undefined }) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    placeholderData: keepPreviousData,
    queryKey: ['knowledge-base', { programYearId }],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarKnowledgeBaseResponse>('/api/knowledge-base', {
        params: {
          programYearId
        },
        signal
      })

      // Sugar emits HTTP 200 with `success: false` for app-level failures
      // (formatErrorResponse). Surface those through React Query's error state
      // instead of letting `data.length` crash.
      if (!data.success) {
        throw new Error(data.messages?.[0]?.message ?? 'Unable to retrieve knowledge base documents at this time.')
      }

      return data
    }
  })
}
